import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useRef, useEffect, useState, useCallback } from 'react';
import IconWrap from '@wix/da-ds/pkg/Icons/IconWrap';
import { getFavouriteOutlineIconMarkup } from '@wix/da-ds/pkg/Icons/24x24/FavStar/FavStar';
import { getFavouriteIconMarkup } from '@wix/da-ds/pkg/Icons/24x24/FavStarFill/FavStarFill';
import s from './FavingIcon.scss';
function getAnimationMarkup(filledStarPath, outlineStarPath) {
    return /*#__PURE__*/ React.createElement("g", {
        className: s['content'],
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        className: s['star-wrapper'],
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        className: s['star']
    }, filledStarPath)), /*#__PURE__*/ React.createElement("g", {
        className: s['star-outline-wrapper']
    }, outlineStarPath), /*#__PURE__*/ React.createElement("g", {
        className: s['sparkle1-wrapper']
    }, /*#__PURE__*/ React.createElement("polygon", {
        className: s['sparkle1'],
        fillRule: "nonzero",
        points: "3.48868458 4 3.31612447 3.86820551 3.41371994 3.2725242 3 2.84363366 3.06577086 2.62993299 3.63790665 2.545793 3.89321075 2 4.10537482 2 4.36209335 2.545793 4.93422914 2.63291139 5 2.84363366 4.58628006 3.26805659 4.68387553 3.86746091 4.51131542 3.9992554 4 3.71705138"
    })), /*#__PURE__*/ React.createElement("g", {
        className: s['sparkle2-wrapper']
    }, /*#__PURE__*/ React.createElement("polygon", {
        className: s['sparkle2'],
        fillRule: "nonzero",
        points: "16.4886846 4 16.3161245 3.86820551 16.4137199 3.2725242 16 2.84363366 16.0657709 2.62993299 16.6379066 2.545793 16.8932107 2 17.1053748 2 17.3620934 2.545793 17.9342291 2.63291139 18 2.84363366 17.5862801 3.26805659 17.6838755 3.86746091 17.5113154 3.9992554 17 3.71705138"
    })), /*#__PURE__*/ React.createElement("g", {
        fillRule: "nonzero",
        className: s['sparkle3-wrapper-wrapper']
    }, /*#__PURE__*/ React.createElement("g", {
        className: s['sparkle3-wrapper']
    }, /*#__PURE__*/ React.createElement("polygon", {
        className: s['sparkle3'],
        points: "0.488684583 2 0.31612447 1.86820551 0.413719943 1.2725242 0 0.843633656 0.0657708628 0.629932986 0.637906648 0.545793001 0.89321075 0 1.10537482 0 1.36209335 0.545793001 1.93422914 0.632911392 2 0.843633656 1.58628006 1.26805659 1.68387553 1.86746091 1.51131542 1.9992554 1 1.71705138"
    }))), /*#__PURE__*/ React.createElement("g", {
        fillRule: "nonzero",
        className: s['sparkle4-wrapper-wrapper']
    }, /*#__PURE__*/ React.createElement("g", {
        className: s['sparkle4-wrapper']
    }, /*#__PURE__*/ React.createElement("polygon", {
        className: s['sparkle4'],
        points: "0.488684583 2 0.31612447 1.86820551 0.413719943 1.2725242 0 0.843633656 0.0657708628 0.629932986 0.637906648 0.545793001 0.89321075 0 1.10537482 0 1.36209335 0.545793001 1.93422914 0.632911392 2 0.843633656 1.58628006 1.26805659 1.68387553 1.86746091 1.51131542 1.9992554 1 1.71705138"
    }))), /*#__PURE__*/ React.createElement("g", {
        fillRule: "nonzero",
        className: s['sparkle5-wrapper-wrapper']
    }, /*#__PURE__*/ React.createElement("g", {
        className: s['sparkle5-wrapper']
    }, /*#__PURE__*/ React.createElement("polygon", {
        className: s['sparkle5'],
        points: "0.488684583 2 0.31612447 1.86820551 0.413719943 1.2725242 0 0.843633656 0.0657708628 0.629932986 0.637906648 0.545793001 0.89321075 0 1.10537482 0 1.36209335 0.545793001 1.93422914 0.632911392 2 0.843633656 1.58628006 1.26805659 1.68387553 1.86746091 1.51131542 1.9992554 1 1.71705138"
    }))), /*#__PURE__*/ React.createElement("g", {
        fillRule: "nonzero",
        className: s['sparkle6-wrapper-wrapper']
    }, /*#__PURE__*/ React.createElement("g", {
        className: s['sparkle6-wrapper']
    }, /*#__PURE__*/ React.createElement("polygon", {
        className: s['sparkle6'],
        points: "0.488684583 2 0.31612447 1.86820551 0.413719943 1.2725242 0 0.843633656 0.0657708628 0.629932986 0.637906648 0.545793001 0.89321075 0 1.10537482 0 1.36209335 0.545793001 1.93422914 0.632911392 2 0.843633656 1.58628006 1.26805659 1.68387553 1.86746091 1.51131542 1.9992554 1 1.71705138"
    }))), /*#__PURE__*/ React.createElement("g", {
        fillRule: "nonzero",
        className: s['sparkle7-wrapper-wrapper']
    }, /*#__PURE__*/ React.createElement("g", {
        className: s['sparkle7-wrapper']
    }, /*#__PURE__*/ React.createElement("polygon", {
        className: s['sparkle7'],
        points: "0.488684583 2 0.31612447 1.86820551 0.413719943 1.2725242 0 0.843633656 0.0657708628 0.629932986 0.637906648 0.545793001 0.89321075 0 1.10537482 0 1.36209335 0.545793001 1.93422914 0.632911392 2 0.843633656 1.58628006 1.26805659 1.68387553 1.86746091 1.51131542 1.9992554 1 1.71705138"
    }))));
}
const FavingIcon = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { isFavourited, deviationId, onAnimationEnd: onAnimationEndProp } = _param, props = _object_without_properties(_param, [
        "isFavourited",
        "deviationId",
        "onAnimationEnd"
    ]);
    const wasFaved = useRef(isFavourited);
    const prevDeviationId = useRef(deviationId);
    const [faveAnimationDone, setFaveAnimationDone] = useState(false);
    const showAnimatedIcon = isFavourited && !wasFaved.current && deviationId === prevDeviationId.current && !faveAnimationDone;
    const onAnimationEnd = useCallback((event)=>{
        onAnimationEndProp && onAnimationEndProp(event);
        if (showAnimatedIcon) {
            setFaveAnimationDone(true);
        }
    }, [
        onAnimationEndProp,
        showAnimatedIcon
    ]);
    useEffect(()=>{
        wasFaved.current = isFavourited;
        prevDeviationId.current = deviationId;
        if (prevDeviationId.current !== deviationId || !isFavourited) {
            setFaveAnimationDone(false);
        }
    }, [
        deviationId,
        isFavourited
    ]);
    return /*#__PURE__*/ React.createElement(IconWrap, _object_spread_props(_object_spread({}, props), {
        onAnimationEnd: onAnimationEnd
    }), /*#__PURE__*/ React.createElement("svg", {
        ref: ref,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: s['root']
    }, showAnimatedIcon ? getAnimationMarkup(getFavouriteIconMarkup(s['fade-in-fill']), getFavouriteOutlineIconMarkup(s['star-outline'])) : isFavourited ? getFavouriteIconMarkup() : getFavouriteOutlineIconMarkup(s['star-outline'])));
});
FavingIcon.displayName = 'FavingIcon';
// avoid animation replaying on pointless re-renders
export default /*#__PURE__*/ React.memo(FavingIcon);

//# sourceMappingURL=FavingIcon.js.map